var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewmapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4722 0L18.3033 0.0316666L12.6667 2.21667L6.33333 0L0.38 2.00556C0.158333 2.07944 0 2.26944 0 2.51222V18.4722C0 18.7678 0.232222 19 0.527778 19L0.696667 18.9683L6.33333 16.7833L12.6667 19L18.62 16.9944C18.8417 16.9206 19 16.7306 19 16.4878V0.527778C19 0.232222 18.7678 0 18.4722 0ZM12.6667 16.8889L6.33333 14.6617V2.11111L12.6667 4.33833V16.8889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewmapIcon);
export default __webpack_public_path__ + "static/media/ViewmapIcon.7ae3c8f073702491b21ada6953a38582.svg";
export { ForwardRef as ReactComponent };